import React from "react";
import { ReprocessDataTaskFragment } from "../../graphql/generated";
import ReprocessDataTaskTableListItem from "./table-list-item";

const ReprocessDataTaskTable: React.FC<{
  tasks?: ReprocessDataTaskFragment[];
  children?: React.ReactNode;
}> = ({ tasks = [] }) => {
  if (!tasks.length) return null;

  return (
    <div className="flex flex-col">
      <div className="bg-white px-2 py-2 grid grid-cols-6 gap-2">
        <p>
          <b>Status</b>
        </p>
        <p>
          <b>MLS</b>
        </p>
        <p>
          <b>% complete</b>
        </p>
        <p>
          <b>ETA</b>
        </p>
        <p>
          <b>Problems (threshold)</b>
        </p>
        <p>
          <b>Remaining listings</b>
        </p>
      </div>

      {tasks.map((task) => (
        <ReprocessDataTaskTableListItem task={task} key={task.id} />
      ))}
    </div>
  );
};

export default ReprocessDataTaskTable;
